import {TaskLeadingVisual} from '@github-ui/agent-sessions/components/TaskLeadingVisual'
import type {IssueAgentTask} from '@github-ui/agent-sessions/hooks/use-issue-agent-tasks'
import {getReadableSessionState, isSessionState} from '@github-ui/agent-sessions/types/session'
import {getTaskTitle} from '@github-ui/agent-sessions/utils/task-helpers'
import {SidePanel} from '@github-ui/side-panel'
import {RelativeTime} from '@primer/react'
import type {RefObject} from 'react'

import styles from './AgentTaskSidePanel.module.css'

type AgentTaskSidePanelProps = {
  task: IssueAgentTask
  open: boolean
  onClose: () => void
  returnFocusRef: RefObject<HTMLElement | null>
}

export function AgentTaskSidePanel({task, open, onClose, returnFocusRef}: AgentTaskSidePanelProps) {
  const title = getTaskTitle(task)
  const taskState = task.state ?? task.status
  const status = isSessionState(taskState) ? taskState : undefined
  const readableStatus = status ? getReadableSessionState(status) : 'Unknown'

  return (
    <SidePanel open={open} onClose={onClose} returnFocusRef={returnFocusRef} aria-label={title} width="400px">
      <SidePanel.Heading>
        <span className={styles.heading}>{title}</span>
      </SidePanel.Heading>
      <div className={styles.headerSeparator} />
      <div className={styles.Panel}>
        <ul className={styles.detailList}>
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Status</span>
            <span className={styles.detailValue}>
              {status && <TaskLeadingVisual sessionState={status} />}
              {readableStatus}
            </span>
          </li>
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Sessions</span>
            <span className={styles.detailValue}>{task.session_count}</span>
          </li>
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Created</span>
            <span className={styles.detailValue}>
              <RelativeTime date={new Date(task.created_at)} />
            </span>
          </li>
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Last updated</span>
            <span className={styles.detailValue}>
              {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
              <RelativeTime date={new Date((task.updated_at ?? task.last_updated_at)!)} />
            </span>
          </li>
        </ul>
        {task.url && (
          <a href={task.url} className={styles.viewDetailsLink}>
            View full details
          </a>
        )}
      </div>
    </SidePanel>
  )
}
